import { useContext } from "react";
import { TranslationsContext } from "./TranslationsContext";
export var useTranslations = function () {
    return useContext(TranslationsContext);
};
